import Component from "../abstracts/Component";

export default class ProductCardSwatchesComponent extends Component {

  get COMPONENTNAME() {
    return "ProductCardSwatchesComponent";
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.swatchesTrigger = this.$component.querySelector('[data-swatches-trigger]');
    this.swatchesLastingItems = this.$component.querySelector('[data-swatches-lasting-items]');
    this.swatches = this.$component.querySelectorAll('[data-js-swatch]');
  }

  handleShowSwatches() {
    this.swatchesTrigger.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.swatches.forEach(swatch => {
        swatch.classList.remove("hidden");
      });
      this.swatchesTrigger = this.$component.querySelector('[data-swatches-trigger]');
      this.swatchesTrigger.classList.add("hidden");
      this.swatchesLastingItems = this.$component.querySelector('[data-swatches-lasting-items]');
      if(this.swatchesLastingItems)
        this.swatchesLastingItems.classList.remove("hidden");
    });
  }

  render() {
    super.render();
    if(this.swatchesTrigger) {
      this.handleShowSwatches();
    }
  }
}
